// src/includes/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer className="text-center py-6 mt-10 bg-gray-900">
      <p className="text-sm text-gray-400">&copy; 2024 Team CodeMe. All rights reserved.</p>
    </footer>
  );
};

export default Footer;